
import {Fetch} from "../../utils/storage"
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import {ParseTime} from "../../utils/time"
import {Api} from "../../utils/api"
import Uploader from "vux-uploader-component";


export default {
name: 'Order-detail',
components: {
Uploader,
XButton,
Flexbox,
FlexboxItem,
},
filters: {
/**
* @return {string}
*/
meetingTimeFilter(val) {
let start = ParseTime(val.StartAt,'{y}-{m}-{d}')
let end = ParseTime(val.EndAt,'{y}-{m}-{d}')
return `${start} 至 ${end}`
},

statusFilter(value) {
return {
to_pay:'待支付',
paid:'已支付',
canceled:'已取消',
refunded:'已退费',
}[value]
}
},
data () {
return {
ID: 0,
OrderMeetingCertificate: {},
}
},
async created () {
if (this.$route.query["ID"]) {
this.ID = this.$route.query["ID"]
this.ID = parseInt(this.ID)
}
if (this.$route.query["MeetingID"]) {
this.MeetingID = this.$route.query["MeetingID"]
this.MeetingID = parseInt(this.MeetingID)
}
this.IDCard = this.$route.query["IDCard"]
this.Name = this.$route.query["Name"]

this.UserID = Fetch("ID")
await this.fetchOrderMeetingCertificate()
},
methods: {
ParseTime,
handleGoToOrderDetail() {
this.$router.go(-1)
},
async fetchOrderMeetingCertificate() {
let Data = {}
if (this.ID) {
Data.ID = this.ID
} else if (this.IDCard && this.MeetingID && this.Name) {
Data.IDCard = this.IDCard
Data.MeetingID = this.MeetingID
Data.Name = this.Name
}
let res = await Api('GetOrderMeetingCertificateList',{
Data: Data
})
if (res.data.List && res.data.List.length === 1) {
this.OrderMeetingCertificate = res.data.List[0]
this.OrderMeetingCertificate.FieldsData = JSON.parse(this.OrderMeetingCertificate.FieldsData)
} else {
this.$vux.toast.show({
text:'获取信息出错',
type:'cancel',
})

}
},
handleMeetingCertificateDownload() {
window.location.href = this.OrderMeetingCertificate.CertificateFilePDF
},
},
}
